import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import ResponsiveImage from '../../ResponsiveImage';
import { jsx as _jsx } from "react/jsx-runtime";
const selectFullBleedContentProps = _ref => {
  let {
    alt,
    height,
    loading,
    src,
    width,
    fallbackSrc = src,
    lgSrc = src,
    mdSrc = src,
    smSrc = src,
    xlSrc = src,
    xsSrc = src
  } = _ref;
  return {
    alt,
    height,
    loading,
    src,
    width,
    fallbackSrc,
    lgSrc,
    mdSrc,
    smSrc,
    xlSrc,
    xsSrc
  };
};
const FullBleedContentContainer = /*#__PURE__*/styled.div.withConfig({
  displayName: "FullBleedContent__FullBleedContentContainer",
  componentId: "components-web__sc-1130ea5-0"
})(_ref2 => {
  let {
    borderBottomLeftRadius,
    borderBottomRightRadius,
    borderTopLeftRadius,
    borderTopRightRadius
  } = _ref2;
  return {
    overflow: 'hidden',
    borderBottomLeftRadius,
    borderBottomRightRadius,
    borderTopLeftRadius,
    borderTopRightRadius
  };
});

/**
 * Full bleed content component can accept either a single source,
 * a number of sources corresponding to the `ResponsiveImage` component API,
 * or a custom component.
 */
const FullBleedContent = _ref3 => {
  let {
    borderRadius,
    content,
    ...rest
  } = _ref3;
  return /*#__PURE__*/_jsx(FullBleedContentContainer, {
    ...borderRadius,
    children: content ?? /*#__PURE__*/_jsx(ResponsiveImage, {
      ...selectFullBleedContentProps(rest)
    })
  });
};
FullBleedContent.propTypes = {
  /**
   * Content border radius matching the edge values on the parent card.
   */
  borderRadius: PropTypes.shape({
    borderBottomLeftRadius: PropTypes.number,
    borderBottomRightRadius: PropTypes.number,
    borderTopLeftRadius: PropTypes.number,
    borderTopRightRadius: PropTypes.number
  }),
  /**
   * Custom JSX to be used for rendering the content (defaults to `ResponsiveImage` receiving other props).
   */
  content: PropTypes.node,
  /**
   * Image source.
   */
  src: PropTypes.string,
  /**
   * Also accept props for `ResponsiveImage`...
   */
  ...ResponsiveImage.propTypes,
  /**
   * ...but make the required ones optional.
   */
  alt: PropTypes.string,
  xsSrc: PropTypes.string,
  smSrc: PropTypes.string,
  fallbackSrc: PropTypes.string
};
export default FullBleedContent;